import nomeEstados from "../../SENAC/views/perfil_trabalhadores/sections/principais_setores/utils/nomeEstados";

export default nomeEstados;